<template>
    <div class="leftmenu-wrapper">
        <!-- Mobile filter toggle button -->
        <div class="filter-mobile-toggle d-md-none">
            <button class="btn btn-filter w-100 d-flex align-items-center justify-content-between" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#mobileSidebarFilters" 
                    aria-expanded="false" aria-controls="mobileSidebarFilters">
                <span><i class="bi bi-funnel me-2"></i> Filtrér produkter</span>
                <i class="bi bi-chevron-down"></i>
            </button>
        </div>
        
        <!-- Filter content - collapsible on mobile -->
        <div id="mobileSidebarFilters" class="collapse d-md-block filter-content">
            <div class="accordion accordion-flush" id="filter-accordian-wrapper">
                <div v-for="group in filters" :key="group.groupId" class="filter-group">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button :class="`accordion-button ${numberOfFilterGroups > 3 ? 'collapsed' : ''}`" 
                                    type="button" data-bs-toggle="collapse" 
                                    :data-bs-target="`#panel-${group.groupId}`" 
                                    :aria-expanded="`${numberOfFilterGroups > 3 ? 'false' : 'true'}`" 
                                    :aria-controls="`panel-${group.groupId}`">
                                {{ group.groupName }}
                            </button>
                        </h2>
                        <div :id="`panel-${group.groupId}`" 
                             :class="`accordion-collapse ${numberOfFilterGroups > 3 ? '' : 'collapse show'}`" 
                             aria-labelledby="panelsStayOpen-headingOne">
                            <div class="accordion-body filter-accordian">
                                <template v-for="filter in group.filters" :key="filter.id">
                                    <div class="filter-element checkbox-filter" data-type="checkbox" 
                                         :data-filter-id="`${filter.id}`" 
                                         :data-filter-slug="`${filter.filter_name_slug}`">
                                        <div class="card border-light filter-card">
                                            <div class="card-body text-left">
                                                <CheckboxFilter :filter="filter" 
                                                                @filterUpdated="onFilterUpdated" 
                                                                :urlParams="queryParameters" />
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Removed the "Anvend filtre" button for mobile as auto-update happens when checkboxes are clicked -->
            <div class="d-md-none pt-2 pb-3 px-3 filter-actions" v-if="false">
                <!-- Button removed -->
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, defineEmits } from 'vue';
import axios from 'axios';
import CheckboxFilter from '../CategoryFilters/CheckboxFilter.vue';

const emit = defineEmits(['filterUpdated']);

const filters = ref([]);
const checkedFilters = ref([]);
const numberOfFilterGroups = ref(0);

// CategoryId from parent
const { categoryId, queryParameters } = defineProps(['categoryId', 'queryParameters']);

// Function for fetching filter data from the server via route category/{categoryId}/filters with axios
const fetchFilters = () => {
    axios.get('/api/v1/category/' + categoryId + '/filters')
        .then(response => {
            filters.value = response.data.data;

            // Set the number of filter groups
            numberOfFilterGroups.value = filters.value.length;
        })
        .catch(error => {
            console.error(error);
        });
}

// When loaded fetch the filters
onMounted(() => {
    fetchFilters();
});

const onFilterUpdated = (filters) => {
    emit('filterUpdated', filters);
}

document.addEventListener('show.bs.collapse', function (event) {

});

document.addEventListener('hide.bs.collapse', function (event) {

});
</script>

<style scoped>
.leftmenu-wrapper {
    background-color: transparent; /* Make it transparent to show the gray background */
    height: 100%;
    border-radius: 0.5rem;
    box-shadow: none; /* Remove shadow to match dashboard style */
    border: none; /* Remove border to match dashboard style */
    position: relative;
    z-index: 1050;
    margin-bottom: 20px; /* Add space at bottom */
}

.filter-mobile-toggle {
    padding: 0.75rem;
    background-color: #ffffff;
    border-radius: 0.5rem;
    margin-bottom: 15px; /* Add space between toggle and content */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.btn-filter {
    background-color: #e9f0f8;
    color: #1E3A8A;
    font-weight: 500;
    border: 1px solid #c5d5e9;
    padding: 0.75rem 1rem;
    border-radius: 0.375rem;
    transition: all 0.2s ease;
}

.btn-filter:hover, .btn-filter:focus {
    background-color: #d8e6f6;
    border-color: #1E3A8A;
}

.filter-content {
    padding: 0;
    background-color: transparent; /* Make it transparent */
}

.filter-element {
    margin-bottom: 0.75rem;
}

.filter-accordian {
    padding: 0.75rem 1rem;
    background-color: #ffffff;
}

.accordion-item {
    margin-bottom: 15px; /* Increase spacing between accordion items */
    border: none;
    border-radius: 0.5rem;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s, box-shadow 0.2s;
}

.accordion-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.accordion-button {
    font-size: 0.95rem;
    font-weight: 600;
    color: #ffffff;
    background-color: #1E3A8A;
    padding: 0.75rem 1rem;
    box-shadow: none;
    text-decoration: none;
}

.accordion-button:not(.collapsed) {
    color: #ffffff;
    background-color: #2a4494;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.accordion-button:focus {
    box-shadow: none;
    border-color: rgba(30, 58, 138, 0.25);
}

.accordion-button::after {
    background-size: 1rem;
    transition: transform 0.2s ease;
    filter: brightness(5); /* Makes the chevron icon white */
}

.accordion-collapse {
    background-color: #fff;
    border-top: 1px solid #eaeaea;
}

.filter-actions {
    position: sticky;
    bottom: 0;
    background-color: #ffffff;
    z-index: 10;
    border-top: 1px solid #dce3e9;
    padding: 15px;
    margin-top: 10px;
    border-radius: 0 0 0.5rem 0.5rem;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.filter-card {
    border: none;
    background-color: transparent;
}

.filter-card .card-body {
    padding: 0.5rem 0;
}

@media (max-width: 767.98px) {
    .leftmenu-wrapper {
        margin-bottom: 15px;
        background-color: transparent;
    }
    
    .filter-content {
        border-radius: 0.5rem;
        padding: 0;
        background-color: transparent;
    }
    
    .accordion-button {
        padding: 0.875rem 1rem;
    }
    
    /* Larger tap targets for mobile */
    .filter-accordian {
        padding: 0.75rem;
    }
    
    #mobileSidebarFilters {
        margin-top: 10px;
    }
}
</style>